import React, { useState } from "react";
import {
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
} from "mdb-react-ui-kit";
import { NewFooter } from "../../components/newFooter";
import "../../styles/index.css";
import "../../styles/askMyEmployer.css";
import butterfly1 from "../../img/Butterfly1.png";
import employer from "../../img/employer-image.png";
import { useDispatch } from "react-redux";
import { createEmployerContact } from "../../features/employerContact/employerContactSlice";

const AskMyEmployer = () => {
  const [employerData, setEmployerData] = useState({
    name: "",
    contactEmail: "",
    contactFirstName: "",
    contactLastName: "",
    companyName: "",
    companySize: "",
    companyHeadquarters: "",
  });
  const handleChange = (e) => {
    setEmployerData({ ...employerData, [e.target.name]: e.target.value });
  };

  const dispatch = useDispatch();

  console.log(employerData);

  const [basicModal, setBasicModal] = useState(false);

  const toggleShow = () => setBasicModal(!basicModal);

  const createNewContact = () => {
    dispatch(createEmployerContact(employerData));
  };

  return (
    <>
      <div className=" bg-purple-ask-employer">
        <div className="padding-logo-aling ">
          {/* EMPLOYER BANNER 1 */}
          <div className="pt-4">
            <h1 className="text-al fs-48-32-30 text-black padding-top-userpages">
              Ask my Employer to Offer Elana
            </h1>
            <p className="fs-20-18">
              Help us elevate the standard for women.
            </p>
            <p className="fs-20-18 text-dm text-black pb-2">
              Ask your employer to get Elana as part of your healthcare benefits
              so you can enjoy:
            </p>
            <ul className="p-0 employer-ul-padding">
              <li className="fs-20-18 text-dm text-black text-start">
                &#x2022;{"   "}Access to pelvic care practitioners via telehealth or in person.
              </li>
              <li className="fs-20-18 text-dm text-black text-start">
                &#x2022;{"   "}Discounts to pelvic care courses and products.
              </li>
              <li className="fs-20-18 text-dm text-black text-start">
                &#x2022;{"   "}A community of women to support you on your
                pelvic care journey.
              </li>
            </ul>
            <p className="fs-20-18 text-dm text-black pt-2">
              Refer your HR team and we will be in touch with them directly.
              <br />
              Don't worry, you don't have to include your name if you don't want
              to.
            </p>
          </div>

          {/* EMPLOYER BANNER 2 */}
          <MDBRow className="mt-4">
            <MDBCol md="12" lg="6">
              <div className="mb-4">
                <p className="m-0 text-dm text-black fs-16">Your Name</p>
                <input
                  className="border-0 input-waitlist border-radius-8 p-2 solid-black-border"
                  type="text"
                  name="name"
                  value={employerData.name}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-4">
                <p className="m-0 text-dm text-black fs-16">HR Contact Email</p>
                <input
                  className="border-0 input-waitlist border-radius-8 p-2 solid-black-border"
                  type="text"
                  name="contactEmail"
                  value={employerData.contactEmail}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-4">
                <p className="m-0 text-dm text-black fs-16">
                  HR Contact First Name
                </p>
                <input
                  className="border-0 input-waitlist border-radius-8 p-2 solid-black-border"
                  type="text"
                  name="contactFirstName"
                  value={employerData.contactFirstName}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-4">
                <p className="m-0 text-dm text-black fs-16">
                  HR Contact Last Name
                </p>
                <input
                  className="border-0 input-waitlist border-radius-8 p-2 solid-black-border"
                  type="text"
                  name="contactLastName"
                  value={employerData.contactLastName}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-4">
                <p className="m-0 text-dm text-black fs-16">Company Name</p>
                <input
                  className="border-0 input-waitlist border-radius-8 p-2 solid-black-border"
                  type="text"
                  name="companyName"
                  value={employerData.companyName}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-4">
                <p className="m-0 text-dm text-black fs-16">Company Size</p>
                <input
                  className="border-0 input-waitlist border-radius-8 p-2 solid-black-border"
                  type="text"
                  name="companySize"
                  value={employerData.companySize}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-4">
                <p className="m-0 text-dm text-black fs-16">
                  State, Region (Company Headquarters)
                </p>
                <input
                  className="border-0 input-waitlist border-radius-8 p-2 solid-black-border"
                  type="text"
                  name="companyHeadquarters"
                  value={employerData.companyHeadquarters}
                  onChange={handleChange}
                />
              </div>
              <p className="mt-5 text-dm text-black fs-12">
                I consent to Elana Inc. processing data I provide, so that Elana
                Inc. can provide services to me. In addition, by clicking ‘Ask
                My Employer’ I acknowledge that I have read and agree to Elana’s
                Privacy Policy and Terms and Conditions. I agree to receive
                emails and updates from Elana Inc.
              </p>
              <div classname="d-flex employer-button">
                <button
                  className="my-4 blue-hover btn text-white text-dm px-5 py-2-3 border-radius-8"
                  onClick={() => {
                    createNewContact();
                    setEmployerData({
                      name: "",
                      contactEmail: "",
                      contactFirstName: "",
                      contactLastName: "",
                      companyName: "",
                      companySize: "",
                      companyHeadquarters: "",
                    });
                    toggleShow();
                  }}
                >
                  ASK MY EMPLOYER
                </button>
              </div>
            </MDBCol>
            <MDBCol
              className="justify-content-end employer-image-hidden "
              md="12"
              lg="6"
            >
              <img
                className="img-employer-fit border-radius-8 mt-4  padding-right"
                src={employer}
                alt="employer"
              />
            </MDBCol>
          </MDBRow>
        </div>
        <MDBModal show={basicModal} setShow={setBasicModal} tabIndex="-1">
          <MDBModalDialog size="lg" rounded className="p-5">
            <MDBModalContent className="bg-modal-option">
              <MDBModalBody>
                <div className="d-flex justify-content-end">
                  <MDBBtn
                    className="btn-close"
                    color="none"
                    onClick={toggleShow}
                  ></MDBBtn>
                </div>
                <div className="items-controller mt-3 mb-3">
                  <img src={butterfly1} className="butterfly1"></img>
                </div>
                <p className="text-center px-3 mt-3 text-dm fs-20">
                  Thank you for Asking your Employer to Offer Elana.
                </p>
                <p className="text-center px-5 mt-3 text-dm fs-20">
                  If you referred your HR team, we will be in touch with them
                  directly. We're so glad to be a part of your pelvic care
                  journey!
                </p>
              </MDBModalBody>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>
      </div>
      <NewFooter />
    </>
  );
};

export default AskMyEmployer;
